/**
 * Paleta categórica de las gráficas del dashboard.
 *
 * Orden fijo: las series/categorías sin color propio toman colores de aquí por
 * índice (`CHART_COLORS[i % CHART_COLORS.length]`), así que el orden importa —
 * agrega colores al final, no en medio.
 */
export const CHART_COLORS = [
  "#1e3a8a", // 1  Azul marino (brand)
  "#2563eb", // 2  Azul (accent)
  "#0891b2", // 3  Cian
  "#0d9488", // 4  Teal
  "#16a34a", // 5  Verde
  "#65a30d", // 6  Verde lima
  "#ca8a04", // 7  Amarillo/dorado
  "#ea580c", // 8  Naranja
  "#dc2626", // 9  Rojo
  "#db2777", // 10 Rosa
  "#7c3aed", // 11 Violeta
  "#475569", // 12 Gris pizarra
  "#94a3b8", // 13 Gris claro
  "#a16207", // 14 Ámbar oscuro
];

// Colores semánticos: mismos significados de siempre (alta=rojo, media=ámbar,
// baja=verde, sin dato=gris), pero tomados de CHART_COLORS para que todo el
// dashboard se lea como un solo sistema.
export const CHART_RED = CHART_COLORS[8]; // #dc2626
export const CHART_ORANGE = CHART_COLORS[7]; // #ea580c
export const CHART_AMBER = CHART_COLORS[6]; // #ca8a04
export const CHART_GREEN = CHART_COLORS[4]; // #16a34a
export const CHART_TEAL = CHART_COLORS[3]; // #0d9488
export const CHART_BLUE = CHART_COLORS[1]; // #2563eb
export const CHART_NAVY = CHART_COLORS[0]; // #1e3a8a
export const CHART_SLATE = CHART_COLORS[11]; // #475569
export const CHART_GRAY = CHART_COLORS[12]; // #94a3b8

// Color de la categoría `i` de una serie sin color explícito.
export const chartColorAt = (i) => CHART_COLORS[i % CHART_COLORS.length];

export default CHART_COLORS;
